import store from "@/store";
import Axios from "axios";

let config = {
  baseURL: store.state.baseApiUrl,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
  headers:{
    'X-Requested-With':'XMLHttpRequest',
  }
};

const axios = Axios.create(config);

axios.interceptors.request.use(
  function(config) {
    let token = localStorage.getItem('token');
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axios;
